import React, { useEffect } from 'react';
import { Users, CheckCircle2, Sparkles, Lock, Video, ArrowRight, ArrowDown } from 'lucide-react';

const WhatsAppIcon = ({ size = 20 }: { size?: number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.002-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.88 11.88 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.82 11.82 0 0 0 20.464 3.49" />
  </svg>
);
import { track } from './track';

const WHATSAPP_URL = 'https://sndflw.com/i/do-zero-ao-mercado-americano';

const PresentePage: React.FC = () => {
  useEffect(() => {
    document.title = 'Seus Presentes | Do Zero ao Mercado Americano';

  }, []);

  const handleWhatsapp = () => {
    track('presente_whatsapp_click');
    window.location.href = WHATSAPP_URL;
  };

  return (
    <div className="min-h-screen bg-[#131314] text-white font-sans selection:bg-flag-100 selection:text-flag-900 overflow-x-hidden">

      {/* Pre-header ticker */}
      <div className="w-full overflow-hidden py-2 sm:py-2.5" style={{ background: 'linear-gradient(90deg, #B31942 0%, #B31942 35%, #0A3161 65%, #0A3161 100%)' }}>
        <div className="flex animate-ticker whitespace-nowrap will-change-transform">
          {Array.from({ length: 20 }).map((_, i) => (
            <span key={i} className="inline-flex items-center gap-2 text-white/90 text-xs sm:text-sm font-bold uppercase tracking-wider mx-4 shrink-0">
              <Sparkles size={14} /> Inscrição Confirmada - Acesse Agora o Grupo VIP
            </span>
          ))}
        </div>
      </div>

      {/* Logo header */}
      <header className="w-full py-5 px-5 sm:px-8 lg:px-[160px] border-b border-slate-800 relative z-10">
        <div className="flex items-center justify-center sm:justify-between">
          <img src="/logo-mobile.webp" alt="Do Zero ao Mercado Americano" className="h-8 lg:h-10 w-auto object-contain" loading="eager" />
          <div className="hidden sm:inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-emerald-950/50 border border-emerald-800/50 text-emerald-400 text-xs font-bold uppercase tracking-wide">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
            </span>
            Inscrição Confirmada
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="relative overflow-hidden border-b border-slate-800">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_rgba(255,255,255,0.04)_1px,_transparent_1px)] [background-size:18px_18px] opacity-40 pointer-events-none"></div>
        <div className="absolute -top-40 -left-40 w-96 h-96 bg-flag-500 opacity-[0.08] rounded-full blur-3xl pointer-events-none"></div>
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-navy-500 opacity-[0.1] rounded-full blur-3xl pointer-events-none"></div>

        <div className="relative z-10 max-w-3xl mx-auto px-5 sm:px-8 pt-12 lg:pt-16 pb-12 lg:pb-16 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-950/50 border border-emerald-800/50 text-emerald-400 text-xs sm:text-sm font-bold uppercase tracking-wide mb-6">
            <CheckCircle2 size={16} />
            Sua vaga está garantida
          </div>

          <h1
            style={{ lineHeight: '1.4' }}
            className="text-[1.75rem] sm:text-4xl lg:text-[3rem] font-heading font-semibold text-white tracking-tight mb-5"
          >
            Obrigado por participar! <span className="font-normal">Você será enviado para o</span> <span className="text-emerald-400 font-bold">GRUPO VIP</span><span className="font-normal">, se não for, clique aqui</span>
          </h1>

          <div className="mt-6 lg:mt-8 flex justify-center">
            <ArrowDown size={36} className="text-emerald-400 animate-bounce" strokeWidth={2.5} />
          </div>

          <div className="mt-4 lg:mt-5 flex justify-center">
            <button
              onClick={handleWhatsapp}
              className="btn-cta btn-cta-pill w-full sm:w-auto shadow-[0_0_30px_rgba(34,197,94,0.35)] text-base sm:text-lg"
            >
              <WhatsAppIcon size={22} />
              Entrar no grupo VIP agora
              <ArrowRight size={18} />
            </button>
          </div>
        </div>
      </section>

      {/* Presente 1 - WhatsApp em destaque */}
      <section className="py-10 lg:py-16 px-5 sm:px-8 lg:px-[160px] border-b border-slate-800">
        <div className="max-w-3xl mx-auto">
          <div className="relative bg-gradient-to-br from-emerald-950/40 to-emerald-900/10 border-2 border-emerald-500/40 rounded-2xl lg:rounded-3xl p-6 sm:p-8 lg:p-12 shadow-[0_0_60px_rgba(34,197,94,0.15)]">

            <div className="flex flex-col sm:flex-row items-center sm:items-start gap-5 sm:gap-8 text-center sm:text-left">
              <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-emerald-500/20 border border-emerald-500/40 flex items-center justify-center text-emerald-400 shrink-0">
                <Users size={32} className="sm:w-10 sm:h-10" />
              </div>

              <div className="flex-1">
                <h2 className="text-2xl sm:text-3xl lg:text-4xl font-heading font-semibold text-white mb-3 leading-[1.2]">
                  Grupo VIP<br className="sm:hidden" /> no WhatsApp
                </h2>
                <div className="space-y-3 text-slate-300 text-[15px] sm:text-base leading-[1.7]">
                  <p>
                    É no grupo que eu <strong className="text-white">Giovanni</strong> e minha equipe enviamos as <strong className="text-white">aulas preparatórias</strong>, o link da transmissão e os próximos presentes.
                  </p>
                  <p className="text-emerald-300 font-medium">
                    Quem não entra no grupo, não recebe os próximos bônus.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Linha do tempo dos próximos presentes */}
      <section className="py-14 lg:py-20 px-5 sm:px-8 lg:px-[160px]">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 lg:mb-12">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-heading font-semibold text-white mb-4 leading-tight">
              O que vem depois?
            </h2>
            <p className="text-slate-400 text-base sm:text-lg">
              Os próximos presentes são liberados <strong className="text-white">no seu WhatsApp</strong>, em sequência:
            </p>
          </div>

          <div className="space-y-4 sm:space-y-5">

            {/* Presente 2 */}
            <div className="relative bg-white/5 border border-slate-700/50 rounded-2xl p-5 sm:p-6 lg:p-7 flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-6 text-center sm:text-left">
              <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-flag-950/50 border border-flag-500/40 flex items-center justify-center text-flag-300 shrink-0">
                <Video size={24} className="sm:w-7 sm:h-7" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="inline-flex items-center px-2.5 py-1 rounded-full bg-flag-950/60 border border-flag-500/30 text-flag-300 text-[10px] sm:text-xs font-bold uppercase tracking-wider mb-2">
                  Presente 2
                </div>
                <h3 className="text-lg sm:text-xl font-heading font-semibold text-white mb-2 leading-[1.3]">
                  Aula exclusiva<br className="sm:hidden" /> Sala ao Vivo Master Trader
                </h3>
                <p className="text-slate-400 text-[15px] sm:text-[15px] leading-[1.7]">
                  Liberada no grupo VIP <strong className="text-white">assim que você entrar</strong>. Aqui eu mostro, na prática, como opero junto com os alunos do Programa Master Trader.
                </p>
              </div>
            </div>

            {/* Presente 3 — Aula 3 */}
            <div className="relative bg-white/5 border border-slate-700/50 rounded-2xl p-5 sm:p-6 lg:p-7 flex flex-col sm:flex-row items-center sm:items-start gap-4 sm:gap-6 text-center sm:text-left">
              <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-navy-950/50 border border-navy-500/40 flex items-center justify-center text-navy-300 shrink-0">
                <Lock size={24} className="sm:w-7 sm:h-7" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="inline-flex items-center px-2.5 py-1 rounded-full bg-navy-950/60 border border-navy-500/30 text-navy-300 text-[10px] sm:text-xs font-bold uppercase tracking-wider mb-2">
                  Presente 3
                </div>
                <h3 className="text-lg sm:text-xl font-heading font-semibold text-white mb-2 leading-[1.3]">
                  Aula 3 - Preparatória bônus
                </h3>
                <p className="text-slate-400 text-[15px] sm:text-[15px] leading-[1.7]">
                  Aula bônus de preparação para o evento, que complementa as anteriores. Liberada no grupo VIP <strong className="text-white">somente após você assistir à aula do Presente 2</strong>, assim você acompanha o conteúdo na ordem certa.
                </p>
              </div>
            </div>
          </div>

          {/* CTA de reforço */}
          <div className="mt-8 lg:mt-10 text-center">
            <button
              onClick={handleWhatsapp}
              className="btn-cta btn-cta-sm btn-cta-pill shadow-[0_0_25px_rgba(34,197,94,0.25)]"
            >
              <WhatsAppIcon size={20} />
              Entrar no grupo para liberar os próximos presentes
            </button>
          </div>
        </div>
      </section>

      {/* Próximos passos */}
      <section className="py-14 lg:py-20 px-5 sm:px-8 lg:px-[160px] bg-gradient-to-r from-navy-900/40 to-flag-900/30 relative overflow-hidden">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-flag-500 opacity-5 rounded-full blur-3xl pointer-events-none"></div>
        <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-navy-500 opacity-5 rounded-full blur-3xl pointer-events-none"></div>

        <div className="relative z-10 max-w-3xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-heading font-semibold text-white mb-5 leading-tight">
            Prepare-se para o evento
          </h2>
          <p className="text-base lg:text-lg text-slate-300 leading-relaxed">
            Nos dias <strong className="text-white">8, 9 e 10 de Junho às 19h30</strong> você recebe o link das aulas ao vivo no e-mail e no grupo VIP do WhatsApp. Enquanto isso, entre no grupo para não perder nenhum bônus.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0e0e0f] border-t border-slate-800 pt-10 pb-8 text-slate-400">
        <div className="w-full px-5 sm:px-8 lg:px-[160px]">
          <div className="flex flex-col md:flex-row justify-between items-center gap-5 text-xs">
            <img src="/logo-mobile.webp" alt="Do Zero ao Mercado Americano" className="h-7 w-auto opacity-60" loading="lazy" />
            <div className="text-center md:text-right space-y-1">
              <p>&copy; {new Date().getFullYear()} Giovanni Paganini · GVSI CAPITAL LTDA - 58.660.640/0001-08</p>
              <p className="text-emerald-400/80">
                Em conformidade com a LGPD · <a href="/privacidade" className="hover:text-white underline">Política de Privacidade</a>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PresentePage;
